<template>
	<v-toolbar
		class="action-toolbar primary navbartext--text mr-3"
		flat
	>
		<v-btn
			title="Atrás"
			class="navbartext--text"
			icon
			@click="back"
		>
			<v-icon>arrow_back</v-icon>
		</v-btn>
		<v-toolbar-title class="bgdarktext hidden-md-and-down">{{ toolbar.title }}</v-toolbar-title>
		<v-spacer></v-spacer>
		<v-btn
			v-for="(action, index) in toolbar.actions"
			:key="index"
			:title="action.name"
			icon
			:class="'navbartext--text ' + action.class"
			flat
			@click="action.action"
		>
			<v-icon size="19px">{{ action.icon }}</v-icon>
		</v-btn>
		
	</v-toolbar>
</template>

<script>
import { router } from '../../sr.js'
import { mapState } from 'vuex'

export default {
	methods: {
		back() {
			router.go(-1)
		}
	},
	computed: {
		...mapState(['toolbar']),		
	}
}
</script>

<style lang="scss">
.action-toolbar > div{
	padding: 0px !important;
}
	.action-toolbar .navbartext--text.green, .action-toolbar .navbartext--text.red {
		color: #ffffff !important;
	}
</style>
